exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ai-box-tooltip-peak{z-index:9999 !important}\n", ""]);

